import { render, staticRenderFns } from "./SearchTerm.vue?vue&type=template&id=15b72c8a"
import script from "./SearchTerm.vue?vue&type=script&lang=js"
export * from "./SearchTerm.vue?vue&type=script&lang=js"
import style0 from "./SearchTerm.vue?vue&type=style&index=0&id=15b72c8a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports